<template>
  <div class="dialog-wrapper">
    <div class="body">
      <div class="box">
        <img :src="imgUrl" style="width: 100%;" alt="">
      </div>
      <div class="btn" @click="$emit('close')">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoticeImgDialog",
  props: {
    imgUrl: {
      type: String,
      default: 'https://order-api.yakult-gz.com.cn/upload/images/tanchuang.png'
    },
    title: String,
    width: String,
    display: String,
    description: String,
  },
}
</script>

<style lang="scss" scoped>
.dialog-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 100;
}

.body {
  background: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 101;
  width: 80%;
  border-radius: 5px;
}

.box {
  overflow: auto;
  padding: 15px 20px;
}

.btn {
  width: 100%;
  background: #ffffff;
  color: red;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  text-align: center;
  height: 40px;
  line-height: 20px;
}
</style>